// @ts-check

/**
 * Masked card numbers are the only form of the card number the funnel sends to platform-purchase.
 * The backend reads the BIN (first six digits) and the last four from it — for the gateway and for
 * Riskified — so the format below keeps exactly those digits and hides everything in between.
 */
const MASK = 'xxxxxx';

/**
 * Builds the masked card number sent to platform-purchase: the first six digits, a fixed mask,
 * and the last four digits (e.g. `411111xxxxxx1111`). The raw number never leaves this function.
 * @param {string | null | undefined} cardNumber - The card number, digits only.
 * @returns {string} The masked card number.
 */
export const maskCardNumber = (cardNumber) =>
  `${cardNumber?.slice(0, 6) || ''}${MASK}${cardNumber?.slice(-4) || ''}`;

/**
 * Whether a card number is already masked: six digits, a run of `X`/`*`, then four digits
 * (e.g. `411111XXXXXX1111`, as OpenPay returns it, or `411111******1111`).
 * @param {unknown} cardNumber - The value to check.
 * @returns {boolean} True when the value hides its middle digits.
 */
export const isMaskedCardNumber = (cardNumber) =>
  typeof cardNumber === 'string' && /^\d{6}[X*]+\d{4}$/i.test(cardNumber);
